module.exports = __webpack_public_path__ + "img/searching-box.72d94088.png";